import { TextRegular } from 'UiKit/typography';

import ColumnJadwalSession from 'View/report/component/columnJadwalSession';
import ColumnAccount from 'View/report/component/columnAccount';

import styles from './styles.module.css';

const tableListSession = ({ t }) => [
  {
    name: t('table.common.scheduleTime'),
    key: 'startedAt',
    width: 235,
    component: ({ value, values }) => <ColumnJadwalSession endedAt={values?.endedAt} startedAt={value} />,
  },
  {
    name: t('table.common.scheduleName'),
    width: 177,
    key: 'title',
    sortKey: 'schedule.title',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.account'),
    width: 200,
    key: 'account',
    component: ({ value }) => <ColumnAccount values={value} />,
  },
  {
    name: t('table.common.hostName'),
    width: 235,
    key: 'hosts',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.studio'),
    width: 168,
    key: 'studio',
    sortKey: 'schedule.studio.name',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.actualDuration'),
    width: 150,
    key: 'duration',
    sortKey: 'duration',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.liveEarnings'),
    width: 207,
    key: 'revenue',
    sortKey: 'revenue',
    labelInfo: t('table.common.tooltipLiveEarnings'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.viewers'),
    width: 167,
    key: 'viewer',
    sortKey: 'viewer',
    labelInfo: t('table.common.tooltipViewers'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.buyer'),
    width: 127,
    key: 'buyer',
    sortKey: 'buyer',
    labelInfo: t('table.common.tooltipBuyer'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.conversionRate'),
    width: 201,
    key: 'conversationRate',
    sortKey: 'conversationRate',
    labelInfo: t('table.common.tooltipConversionRate'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.ctr'),
    width: 127,
    key: 'ctr',
    sortKey: 'ctrPercentage',
    labelInfo: t('table.common.tooltipSessionCtr'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.awd'),
    width: 267,
    key: 'avgViewDuration',
    sortKey: 'fulltimeAvgViewDuration',
    labelInfo: t('table.common.tooltipSessionAvgViewDuration'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.err'),
    width: 150,
    key: 'errPercentage',
    sortKey: 'errPercentage',
    labelInfo: t('table.common.tooltipErr'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('table.common.aov'),
    width: 250,
    key: 'averageOrderValue',
    sortKey: 'averageOrderValue',
    labelInfo: t('table.common.tooltipAov'),
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
];

export default tableListSession;
